@if (dataSource) {
  @if (triggeredDataSource) {
    @let isLoading = triggeredDataSource.isLoading$ | async;
    @if (isLoading) {
      <div class="loading">
        <shared-local-dot-loader />
      </div>
    } @else if (maxLoopCountExceeded$ | async) {
      <div class="loading-empty">
        <p class="m-t-24">Data loading exceeded maximum loop count. Please refine your filters or contact support.</p>
      </div>
    } @else if (triggeredDataSource.isEmpty$ | async) {
      <div class="loading-empty">
        <p class="m-t-24">No data available.</p>
      </div>
    }
  } @else if (isEmpty) {
    <div class="loading-empty">
      <p class="m-t-24">No data available.</p>
    </div>
  }
}
